import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Tag, TagKind } from 'mbs-ui-shared@models/tag';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TagsService {
  private http = inject(HttpClient);

  public getTagsByKind(kind: TagKind, calculateCount = true): Observable<Tag[]> {
    return this.http.get<Tag[]>(`api/tags?kind=${kind}&calculateCount=${calculateCount}`);
  }

  public getTagById(id: number): Observable<Tag> {
    return this.http.get<Tag>(`api/tags/${id}`);
  }

  public createTag(tag: Partial<Tag>): Observable<Tag> {
    return this.http.post<Tag>(`api/tags`, tag);
  }

  public updateTag(tag: Partial<Tag>): Observable<Tag> {
    return this.http.put<Tag>(`api/tags/${tag?.id}`, tag);
  }

  public deleteTag(id: number): Observable<null> {
    return this.http.delete<null>(`api/tags/${id}`);
  }
}
